module.exports = "https://static.energy5.com/_next/static/images/thirdStepHIWImage-a98b2f664a5079ab83d8d85ba6084b7d.jpg";